var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"mobile-navigator-timeline",on:{"click":_vm.openTimeline}},[_c('span',{class:{'has-filters-indicator': _vm.beforeYear !== null}},[_c('app-icon',{attrs:{"icon":"timeline-label","is-active":_vm.isTimelineOpen}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }